import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'temporalIntlFormat',
})
export class TemporalIntlFormatPipe implements PipeTransform {
	transform(
		value: Temporal.ZonedDateTime,
		options: Intl.DateTimeFormatOptions,
		locale?: string,
	): string {
		if (value == null) return '';

		const resolved: Intl.DateTimeFormatOptions = {
			timeZone: value.timeZoneId,
			...options,
		};

		return new Intl.DateTimeFormat(locale ?? 'en-US', resolved).format(
			value.toInstant(),
		);
	}
}
